import React from 'react';

export default function Hero() {
  return (
    <section className="bg-[#121212] text-white py-14 text-center px-4">
      <div className="max-w-4xl mx-auto rounded-2xl border border-white/10 bg-[#171717] px-6 py-10 shadow-lg md:px-8 md:py-12">
        <p className="text-xs uppercase tracking-[0.2em] text-blue-400 mb-3">
          Welcome to FlowQuant
        </p>

        <h1 className="text-3xl md:text-5xl font-extrabold mb-3 tracking-tight">
          <span className="text-white">Flow</span>
          <span className="text-blue-500">Quant</span>
        </h1>

        <h2 className="text-lg md:text-xl text-white mb-4 font-semibold">
          Smarter Trade Decisions, Backed by Real Insight.
        </h2>

        <p className="text-sm md:text-base text-slate-300 max-w-2xl mx-auto leading-8">
          FlowQuant helps traders evaluate risk, journal performance, and turn
          raw trade data into clearer decision-making. Built for traders who
          want more structure, better discipline, and smarter execution.
        </p>

        <p className="text-xs md:text-sm text-gray-500 mt-5">
          A cleaner workflow for traders who value structure and clarity.
        </p>
      </div>
    </section>
  );
}